import React, { useEffect, useState } from 'react';
import { Field, Form as FormFinal } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { FieldArray } from 'react-final-form-arrays';
import { Form, Card, Button } from 'react-bootstrap';
import { connect } from 'react-redux';

//Components
import { camporadio } from '../campos/campos';

//TOOLS
import { getTraducaoTrocaPor as trad } from '../../../utils/getTraducoes';

//Utils
import { getEvento } from '../../../utils/eventosessioncred';

const TermosForm = (props) => {
    
    const [termos, setTermos] = useState([]);
    const evento = getEvento();
    const [lidos, setLidos] = useState([]);
    const [todosLidos, setTodosLidos] = useState(false);
    const required = value => (value ? undefined : "Obrigatório");

    useEffect(() => {
        load();        
    },[]);
    
    const load = () => {        
        const result = props.termos;
        let lidos_array = [];
        result.map((itens, indice) => {
            if(itens.portugues.length < 500){
                lidos_array[indice] = true;
            }
        });

        if(lidos_array.length){
            setLidos(lidos_array);
        }
        
        if(lidos_array.length>0 && lidos_array.length===result.length){
            setTodosLidos(true);
        }
                
        setTermos(result);
    }
    
    const handleSubmit = (form) => {
        const ids = [];
        form.formtermos.forEach(itens => {
            ids.push({
                idtermos: itens.idtermos[0]
            });
        });
        setTimeout(() => {
            props.handleCloseTermos(JSON.stringify(ids));
        },500)        
    }

    window.addEventListener('scroll', (event) => {
        
        if(event.target.scrollTopMax === event.target.scrollTop){
            const lidos_verificar = [...lidos];
            const existe = lidos_verificar.filter(itens => (itens.id===event.target.id));            
            if(existe.length===0){
                lidos_verificar.push({id: event.target.id})
                setLidos(lidos_verificar);
            }
            if(lidos_verificar.length===termos.length){
                setTodosLidos(true);
            }
        }
    },true);
    
    return (            
        <FormFinal        
        onSubmit={handleSubmit}
        name="formTermos"
        validate={(form) => {
            const errors = [];
            if(form.formtermos&&form.formtermos.length){
                const errors_campo = {};
                form.formtermos.forEach(itens => {
                    if(!itens.idtermos){
                        errors_campo.idtermos = 'Obrigatório';
                        errors.push(errors_campo);
                    }                    
                });
            }
            return errors.length?{formtermos: errors}:undefined;
        }}
        mutators={{
        // potentially other mutators could be merged here
        ...arrayMutators
        }}
        render={({form, handleSubmit, errors}) => {      
            
            return (                    
                <form onSubmit={handleSubmit}>                    
                    <FieldArray name="formtermos">        
                        {({fields}) => (
                            termos?termos.map((itens, indice) => (      
                                <Card.Body key={indice}>                                
                                <Form.Row className="mb-4">
                                    <Card style={{height: '200px', overflowY: 'scroll'}} id={`termos${indice}`} dangerouslySetInnerHTML={{__html: itens.portugues}} />                                    
                                </Form.Row>
                                <Form.Row className="mb-4">
                                    <Field type='checkbox' disabled={lidos[indice]?false:true} validate={required} name={`formtermos[${indice}].idtermos`} label='Li e Aceito' value={itens.idfaq} component={camporadio} />
                                </Form.Row>
                                </Card.Body>
                            ))
                            :
                            null
                        )}
                    </FieldArray>
                    {todosLidos===true&&!errors.formtermos?
                    <Form.Row>
                        <Button type="submit">Confirmar</Button>
                    </Form.Row>
                    :
                    null
                    }                    
                </form>
            )}
            }
        />                    
    );    
}

export default connect()(TermosForm);